import { Box, Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useAddSection } from './AddSection.hooks'

const AddSection = props => {
	const [{ classes }, { handleAddSection, handleMouseEnter, handleMouseLeave }] = useAddSection(props)

	return (
		<Box className={classes.root}>
			<Button
				className={classes.addSection}
				onClick={handleAddSection}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				<AddIcon />
			</Button>
		</Box>
	)
}

AddSection.propTypes = {
	index: PropTypes.number.isRequired,
	onMouseEnter: PropTypes.func.isRequired,
	onMouseLeave: PropTypes.func.isRequired,
	offset: PropTypes.number,
}

export default memo(AddSection)
